// extracted by mini-css-extract-plugin
module.exports = {"InfoBoxRowContainer":"DettaglioCorsoStd_InfoBoxRowContainer__3qDqR","Testo":"DettaglioCorsoStd_Testo__3TJYp","IconaMappa":"DettaglioCorsoStd_IconaMappa__cRgXR"};